import { useMemo } from "react";
import type { StripeElementsAddressElementOptions } from "../../../StripeElements/types";

export const useAddressElementDisplay =
  (): StripeElementsAddressElementOptions["display"] =>
    useMemo(
      () => ({
        // We always display the full name. No support for organizations yet.
        name: "full",
      }),
      [],
    );
